import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "@emailjs/browser";
import {
  Send as SendIcon,
  Call as CallIcon,
  AccessTime as AccessTimeIcon,
  LocationOn as LocationOnIcon,
  Search as SearchIcon,
  Check as CheckIcon,
} from "@mui/icons-material";
import { navigate } from "gatsby";

const ContactUs = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    loading: false,
    success: false,
  });
  const [token, setToken] = useState("");
  const siteKey = "6LdTYnknAAAAAEUBgCdOjFC3jEBb6iOldVjBdMCt";

  const handleCaptchaChange = (reCaptchaToken) => setToken(reCaptchaToken);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };
  const handleSubmit = async (e) => {
    e?.preventDefault();
    const values = {
      firstName: form.firstName,
      lastName: form.lastName,
      email: form.email,
      phone: form.phone,
      message: form.message,
    };

    if (token) {
      setForm((prevState) => {
        return {
          ...prevState,
          loading: true,
        };
      });

      const url = window.location.href;
      const emailData = {
        subject: `Referer: ${url}`,
        from_name: `ADC Contact Referer: ${url}`,
        ...values,
      };

      emailjs
        .send(
          "service_p5cs97s",
          "template_96xnlnh",
          emailData,
          "PvTyuGGKn4qTGC0S7"
        )
        .then(
          (result) => {
            setForm({
              firstName: "",
              lastName: "",
              email: "",
              phone: "",
              message: "",
              loading: false,
              success: true,
            });

            navigate("/next-step/");
          },
          (error) => {
            setForm((prevState) => {
              return {
                ...prevState,
                loading: false,
                success: false,
              };
            });
            console.log(error);
          }
        );
    } else {
      alert("Please verify that you are not a robot.");
    }
  };

  return (
    <section className="bg-white py-16">
      <div className="container text-center">
        <div className="rounded-[20px] shadow-medium">
          <div className="flex flex-col md:flex-row justify-between overflow-x-hidden">
            <div className="p-6 w-full md:w-2/4 lg:w-2/3">
              <h1 className="text-2xl md:text-3xl font-bold text-black uppercase text-left mb-10">
                <span className="border-b-3 border-sky-800 pb-4">Send us</span>{" "}
                a message
              </h1>

              <form className="w-full text-start" onSubmit={handleSubmit}>
                <div className="mb-6">
                  <input
                    type="text"
                    name="firstName"
                    id="firstName"
                    placeholder="First Name"
                    className="transition border-2 rounded py-2 px-3 w-full text-black focus:border-sky-600 focus:outline-none focus:shadow-outline"
                    value={form.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-6">
                  <input
                    type="text"
                    name="lastName"
                    id="lastName"
                    placeholder="Last Name"
                    className="transition border-2 rounded py-2 px-3 w-full text-black focus:border-sky-600 focus:outline-none focus:shadow-outline"
                    value={form.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-6">
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Email"
                    className="transition border-2 rounded py-2 px-3 w-full text-black focus:border-sky-600 focus:outline-none focus:shadow-outline"
                    onChange={handleChange}
                    value={form.email}
                    required
                  />
                </div>
                <div className="mb-6">
                  <input
                    type="number"
                    name="phone"
                    id="phone"
                    placeholder="Phone"
                    className="transition border-2 rounded py-2 px-3 w-full text-black focus:border-sky-600 focus:outline-none focus:shadow-outline"
                    onChange={handleChange}
                    value={form.phone}
                    required
                  />
                </div>
                <div className="mb-6">
                  <textarea
                    name="message"
                    id="message"
                    placeholder="Please tell us more about your situation and the best time to contact you."
                    className="transition border-2 rounded py-2 px-3 w-full text-black focus:border-sky-600 focus:outline-none focus:shadow-outline"
                    onChange={handleChange}
                    value={form.message}
                    rows={4}
                    required
                  />
                </div>

                <p className="text-sm text-gray-600 my-8">
                  I agree to be contacted by phone, SMS, or email.
                </p>

                <div className="mb-6">
                  <ReCAPTCHA onChange={handleCaptchaChange} sitekey={siteKey} />
                </div>

                <button
                  className="transition duration-300 bg-dark-green hover:bg-green-700 text-white font-bold p-4 rounded-full flex justify-center border-radius-5 ms-8"
                  disabled={form.loading}
                  type="submit"
                >
                  {form.loading ? (
                    <div className="animate-spin rounded-full border-t-4 border-white h-6 w-6 mx-auto" />
                  ) : (
                    <SendIcon />
                  )}
                </button>

                {form.success && (
                  <div className="mt-4 text-center">
                    <CheckIcon className="text-sky-700" />
                    <p className="text-sky-700 text-xl font-semibold">
                      Thank you for contacting us! One of our Texas Debt
                      Specialists will be in touch with you shortly. For
                      immediate assistance, please call 800-816-1003
                    </p>
                  </div>
                )}
              </form>
            </div>
            <div className="p-10 w-full md:w-2/4 lg:w-1/3 bg-greenGradient rounded-b-[20px] md:rounded-l-none md:rounded-r-[20px] text-start">
              <h3 className="text-2xl md:text-3xl font-bold text-white text-left mb-10">
                Contact Information
              </h3>
              <a
                className="text-white text-lg font-bold flex items-center mb-6"
                href="tel:800-816-1003"
              >
                <CallIcon className="me-1" /> 800-816-1003
              </a>
              <p className="text-white text-lg flex mb-6 font-semibold">
                <AccessTimeIcon className="me-1" /> Mon - Sat: 6 AM – 10 PM CT{" "}
                <br /> Sun: 7 AM - 10 PM CT
              </p>
              <p className="text-white text-lg flex mb-6 font-semibold">
                <LocationOnIcon className="me-1" />{" "}
                <span>
                  <strong>Affordable Debt Consolidation</strong> <br /> 40 NE
                  Interstate 410 Loop <br />
                  Suite 565 <br />
                  San Antonio, TX 78216
                </span>
              </p>
              <p className="text-white text-lg flex font-semibold">
                <SearchIcon className="me-1" /> Please Contact Us For Additional
                Branch Locations
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
